import { useContext, useEffect, useState } from "react";
import "emoji-mart/css/emoji-mart.css";
import auth from "../../components/Layout/util/auth";
import eventBus from "../../util/eventBus";
import Layout from "../../components/Layout/Layout";
import CommunityList from "../../src/components/feature/community/list";
import CommunityMember from "../../src/components/feature/community/member";
import CommunityMessage from "../../src/components/feature/community/message";
import MobileHeader from "../../src/components/feature/community/mobile-header";
import { useRouter } from "next/router";
import { NextSeo } from "next-seo";
import { io } from "socket.io-client";
import { CommonContext } from "../../components/helper/commonContext";
import { setDisplayAnnouncement } from "../../src/redux/slices/home";
import { useDispatch } from "react-redux";

const CommunityChannelById = () => {
  const router = useRouter();
  const { slug } = router.query;
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(true);
  const [mobileHeader, setMobileHeader] = useState(false);
  const [communityTitle, setCommunityTitle] = useState("");
  const [user, setUser] = useState(auth());
  const [section, setSection] = useState("list");
  const [collaps, setCollaps] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const commonContext = useContext(CommonContext);
  const socket = commonContext.socket;

  useEffect(() => {
    eventBus.on("userLoggedIn", () => {
      checkAuth();
    });
    handleWindowSizeChange();
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      dispatch(setDisplayAnnouncement(true));
      // console.log("setDisplayAnnouncement");
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    if (!user.token) {
      eventBus.dispatch("openLoginModal", { function_name: "unique" });
    }
    setIsLoggedIn(!!user.token);
  }, [user]);

  useEffect(() => {
    if (!!user.token && (socket == null || socket.connected == false)) {
      console.log("creating socket obj", process.env.NEXT_PUBLIC_SOCKET_URL, {
        auth: { token: "Bearer " + user.token },
      });
      var socketObj = io(process.env.NEXT_PUBLIC_SOCKET_URL, {
        auth: { token: "Bearer " + user.token },
      });
      socketObj.on("connect", () => {
        console.log("inside socket connect, socketbadlega  ", socketObj.id);
        commonContext.setSocket(socketObj);
        commonContext.setSocketId(socketObj.id);
      });
      console.log("Set Socket called ", socket);
      //
    }
  }, [user, commonContext.socketId]);

  useEffect(() => {
    console.log("socket Mera socket badal gaya", socket);
  }, [socket]);

  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth < 768);
  };
  const checkAuth = () => {
    setUser(auth());
  };
  const goTo = (type) => {
    setSection(type);
    setMobileHeader(type != "list");
  };

  return (
    <>
      <NextSeo
        title={
          "FanTiger Community : Discuss all things music, artists, nft, etc"
        }
        description={
          "FanTiger Community : Discuss all things music, artists, nft, etc"
        }
        canonical="https://fantiger.com/community"
        openGraph={{
          title:
            "FanTiger Community : Discuss all things music, artists, nft, etc",
          description:
            "Join World's First Golbal Music Community | Engage & Earn",
          type: "website",
          url: "https://fantiger.com/community",
          images: [
            {
              url: "https://d2q23p4t0ij9e0.cloudfront.net/Coummnity_11zon_358802256d.jpg",
            },
          ],
          site_name: "FanTiger Waitlist",
        }}
      />
      {isLoggedIn ? (
        <>
          {isMobile && mobileHeader && (
            <MobileHeader
              communityTitle={communityTitle}
              type={section}
              goTo={goTo}
            />
          )}
          <div
            className={
              collaps
                ? `community_wrap collaps ${isMobile ? "mobile" : ""}`
                : `community_wrap ${isMobile ? "mobile" : ""}`
            }
          >
            {isMobile ? (
              <>
                {section == "list" && (
                  <CommunityList
                    isMobile={isMobile}
                    goTo={goTo}
                    setCommunityTitle={setCommunityTitle}
                    community={slug ? slug[0] : null}
                    channel={slug ? slug[1] : null}
                  />
                )}
                {section == "message" && (
                  <CommunityMessage
                    user={user}
                    setCollaps={setCollaps}
                    collaps={collaps}
                    isMobile={isMobile}
                    goTo={goTo}
                    community={slug ? slug[0] : null}
                    channel={slug ? slug[1] : null}
                  />
                )}
                {section == "member" && (
                  <CommunityMember
                    user={user}
                    isMobile={isMobile}
                    goTo={goTo}
                  />
                )}
              </>
            ) : (
              <>
                <CommunityList
                  community={slug ? slug[0] : null}
                  channel={slug ? slug[1] : null}
                />
                <CommunityMessage
                  user={user}
                  setCollaps={setCollaps}
                  collaps={collaps}
                  community={slug ? slug[0] : null}
                  channel={slug ? slug[1] : null}
                />
                <CommunityMember
                  community={slug ? slug[0] : null}
                  channel={slug ? slug[1] : null}
                  user={user}
                />
              </>
            )}
          </div>
        </>
      ) : (
        <Layout hideHeader={mobileHeader}> </Layout>
      )}
    </>
  );
};
export default CommunityChannelById;
